import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from '@common/models';

export interface IQuestionListValueModel extends IModel {
  questionListValueId: number;
  questionId: number;
  name: string;
  sortOrder: number;
  storage: string;
}

export class QuestionListValueModel
  extends Model
  implements ModelRecord<IQuestionListValueModel>
{
  questionListValueId: number;
  questionId: number;
  name: string;
  sortOrder: number;
  storage: string;

  constructor(params?: Partial<IQuestionListValueModel>) {
    super(params);
    this.questionListValueId = defaultTo(params?.questionListValueId, 0);
    this.questionId = defaultTo(params?.questionId, 0);
    this.name = defaultTo(params?.name, '');
    this.sortOrder = defaultTo(params?.sortOrder, 0);
    this.storage = defaultTo(params?.storage, '');
  }
}
